module.exports = __webpack_public_path__ + "img/workContents03_pc.df111e63.png";